import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CommingSoon from '../pages/commingSoon/CommingSoon'
import HomePage from '../pages/homePage/HomePage'
import SeeProjects from '../pages/seeProjects/SeeProjects'

const Routers = () => {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/see-projects' element={<SeeProjects />} />
      {/* <Route path='/coming-soon' element={<CommingSoon />} /> */}
    </Routes>
  )
}
export default Routers
